import { render, staticRenderFns } from "./company-jput.vue?vue&type=template&id=58d2a708&scoped=true&"
import script from "./company-jput.vue?vue&type=script&lang=js&"
export * from "./company-jput.vue?vue&type=script&lang=js&"
import style0 from "./company-jput.vue?vue&type=style&index=0&id=58d2a708&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2a708",
  null
  
)

export default component.exports